import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppSettingsService as _appSettings } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class ClimateService {

  constructor(private _http: HttpClient, private _auth: AuthService) { }

  public model = 'climate';

  list(filter): Observable<Climate> {
    const month = filter.month ? '&month=' + (filter.month) : '';
    const station = filter.station ? '&station=' + (filter.station) : '';
    const params = `?${month}&${station}`;
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + params;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<Climate>(uri, {headers: headers});
  }
  cities(): Observable<CityItem[]> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/cities';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<CityItem[]>(uri, {headers: headers});
  }

  records(filter): Observable<Record> {
    const station = filter.station ? '&station=' + (filter.station) : '';
    const params = `?${station}`;
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/records' + params;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<Record>(uri, {headers: headers});
  }
}

interface Climate {
  cr_year: number,
  data: ClimateItem[]
}
interface ClimateItem {
  city_id: number,
  day_month: string,
  temp_avg: number,
  temp_max_avg: number,
  temp_max: number,
  temp_max_year: number,
  temp_min_avg: number,
  temp_min: number,
  temp_min_year: number,
  prec_max: number,
  prec_max_year: number
}
interface CityItem {
  id: number,
  name: string,
  cr_year: number
}
interface Record {
  "byCity": {
    "city_id": number,
    "temp_max": number,
    "temp_max_year": number,
    "temp_min": number,
    "temp_min_year": number,
    "prec_max": number,
    "prec_max_year": number
  },
  "minTemp": {
    "city_id": number,
    "temp_min": number,
    "temp_min_year": number,
    "NAME_ST": string
  },
  "maxTemp": {
    "city_id": number,
    "temp_max": number,
    "temp_max_year": number,
    "NAME_ST": string
  },
  "maxPrec": {
    "city_id": number,
    "prec_max": number,
    "prec_max_year": number,
    "NAME_ST": string
  }
}
